/* tslint:disable */

declare var Object: any;
export interface TtamondutypurposetypeInterface {
  "purposeCode": string;
  "purposeNameEn"?: string;
  "purposeNameId"?: string;
  "purposeNameMy"?: string;
  "purposeNameTh"?: string;
  "companyId": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "attendCode"?: string;
  ttarondutypurposecomps?: any[];
  rel_purallow?: any[];
  viewondutypurposeitems?: any[];
}

export class Ttamondutypurposetype implements TtamondutypurposetypeInterface {
  "purposeCode": string;
  "purposeNameEn": string;
  "purposeNameId": string;
  "purposeNameMy": string;
  "purposeNameTh": string;
  "companyId": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "attendCode": string;
  ttarondutypurposecomps: any[];
  rel_purallow: any[];
  viewondutypurposeitems: any[];
  constructor(data?: TtamondutypurposetypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttamondutypurposetype`.
   */
  public static getModelName() {
    return "Ttamondutypurposetype";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttamondutypurposetype for dynamic purposes.
  **/
  public static factory(data: TtamondutypurposetypeInterface): Ttamondutypurposetype{
    return new Ttamondutypurposetype(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttamondutypurposetype',
      plural: 'Ttamondutypurposetypes',
      path: 'Ttamondutypurposetypes',
      properties: {
        "purposeCode": {
          name: 'purposeCode',
          type: 'string'
        },
        "purposeNameEn": {
          name: 'purposeNameEn',
          type: 'string'
        },
        "purposeNameId": {
          name: 'purposeNameId',
          type: 'string'
        },
        "purposeNameMy": {
          name: 'purposeNameMy',
          type: 'string'
        },
        "purposeNameTh": {
          name: 'purposeNameTh',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "attendCode": {
          name: 'attendCode',
          type: 'string'
        },
      },
      relations: {
        ttarondutypurposecomps: {
          name: 'ttarondutypurposecomps',
          type: 'any[]',
          model: ''
        },
        rel_purallow: {
          name: 'rel_purallow',
          type: 'any[]',
          model: ''
        },
        viewondutypurposeitems: {
          name: 'viewondutypurposeitems',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttamondutypurposetype.ts